import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiPlusCircle, FiUsers, FiSearch } from "react-icons/fi";

const CreateGroupChat = () => {
  const [groups, setGroups] = useState([
    { id: 1, name: "Tosin Group CTO", members: 12, description: "Coordinate PCV activities across polling units." },
    { id: 2, name: "Baa Moridiyah Coalition", members: 45, description: "Coalition for campaign and volunteer coordination." },
    { id: 3, name: "TechOps Team", members: 18, description: "Manage backend systems and tools." },
    { id: 4, name: "State Leaders Forum", members: 25, description: "Weekly updates from state administrators." },
    { id: 5, name: "Media & Comms", members: 33, description: "Public relations and media outreach team." },
    { id: 6, name: "Voter Mobilization", members: 29, description: "Organize field outreach and voter drives." },
    { id: 7, name: "Analytics Team", members: 14, description: "Data tracking and analytics group." },
    { id: 8, name: "Executive Board", members: 7, description: "Leadership coordination and executive discussions." },
  ]);

  const [newGroup, setNewGroup] = useState({ name: "", description: "", members: "" });
  const navigate = useNavigate();

  const handleCreateGroup = (e) => {
    e.preventDefault();
    if (!newGroup.name || !newGroup.description || !newGroup.members) return;

    const newGroupData = {
      id: groups.length + 1,
      name: newGroup.name,
      description: newGroup.description,
      members: parseInt(newGroup.members),
    };

    setGroups([newGroupData, ...groups]);
    setNewGroup({ name: "", description: "", members: "" });
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <h1 style={styles.title}>Group Chat Management</h1>
      <p style={styles.subtitle}>Create and manage your group conversations seamlessly.</p>

      {/* Search Bar */}
      {/* <div style={styles.searchBarWrapper}>
        <div style={styles.searchBar}>
          <FiSearch style={{ marginRight: "8px", color: "#2563eb" }} />
          <input type="text" placeholder="Search group..." style={styles.searchInput} />
        </div>
      </div> */}

      {/* Layout */}
      <div style={styles.groupContainer}>
        {/* Group List */}
        <div style={styles.groupList}>
          {groups.map((group) => (
            <div
              key={group.id}
              style={styles.groupItem}
              onClick={() => navigate(`/admin/create-group-chat/${group.id}`)}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
            >
              <div>
                <h3 style={styles.groupName}>{group.name}</h3>
                <p style={styles.groupDesc}>{group.description}</p>
              </div>
              <p style={styles.memberCount}>
                <FiUsers /> {group.members}
              </p>
            </div>
          ))}
        </div>

        {/* Create Group Form */}
        <div style={styles.createGroup}>
          <h3 style={styles.formTitle}><FiPlusCircle /> Create New Group</h3>
          <form onSubmit={handleCreateGroup}>
            <label style={styles.label}>Group Name</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Enter group name"
              value={newGroup.name}
              onChange={(e) => setNewGroup({ ...newGroup, name: e.target.value })}
            />

            <label style={styles.label}>Description</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Enter description"
              value={newGroup.description}
              onChange={(e) => setNewGroup({ ...newGroup, description: e.target.value })}
            />

            <label style={styles.label}>Members</label>
            <input
              style={styles.input}
              type="number"
              placeholder="Number of members"
              value={newGroup.members}
              onChange={(e) => setNewGroup({ ...newGroup, members: e.target.value })}
            />

            <button type="submit" style={styles.createBtn}>Create Group</button>
          </form>
        </div>
      </div>
    </div>
  );
};

// Responsive styles
const styles = {
  container: {
    padding: "30px 15px",
    fontFamily: "Inter, sans-serif",
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
    boxSizing: "border-box",
  },
  title: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#2563eb",
    marginBottom: "5px",
    textAlign: "center",
  },
  subtitle: {
    fontSize: "15px",
    color: "#6b7280",
    marginBottom: "25px",
    textAlign: "center",
  },
  searchBarWrapper: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "25px",
  },
  searchBar: {
    display: "flex",
    alignItems: "center",
    background: "#fff",
    borderRadius: "25px",
    padding: "10px 18px",
    boxShadow: "0 3px 10px rgba(0,0,0,0.05)",
    width: "100%",
    maxWidth: "400px",
  },
  searchInput: {
    flex: 1,
    border: "none",
    outline: "none",
    fontSize: "14px",
    background: "transparent",
  },
  groupContainer: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "25px",
  },
  groupList: {
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    border: "1px solid #e5e7eb",
    padding: "20px",
    maxHeight: "70vh",
    overflowY: "auto",
  },
  groupItem: {
    padding: "15px",
    borderBottom: "1px solid #e5e7eb",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#fff",
    transition: "background 0.2s ease",
    flexWrap: "wrap",
  },
  groupName: { margin: 0, fontSize: "15px", fontWeight: 600, color: "#111827" },
  groupDesc: { margin: 0, fontSize: "13px", color: "#6b7280" },
  memberCount: { fontSize: "13px", color: "#2563eb", display: "flex", alignItems: "center", gap: "4px" },
  createGroup: {
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    border: "1px solid #e5e7eb",
    padding: "25px",
  },
  formTitle: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#1e293b",
    fontWeight: "600",
    marginBottom: "15px",
    fontSize: "16px",
  },
  label: { display: "block", marginTop: "10px", fontSize: "13px", color: "#374151" },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    marginTop: "5px",
    fontSize: "14px",
    outlineColor: "#2563eb",
  },
  createBtn: {
    marginTop: "15px",
    width: "100%",
    padding: "12px",
    backgroundColor: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "14px",
  },
};

// Add media queries dynamically
if (typeof window !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.innerText = `
    @media (min-width: 768px) {
      div[style*="grid-template-columns: 1fr"] {
        grid-template-columns: 2fr 1fr !important;
      }
    }
  `;
  document.head.appendChild(styleSheet);
}

export default CreateGroupChat;